export enum FilterDimensionStatus {
  FullyReturned = 'FullyReturned',
  PartiallyReturned = 'PartiallyReturned',
  UnboundedFilterValues = 'UnboundedFilterValues',
}
